module.exports = __webpack_public_path__ + "static/media/bim-rugaojindujinding.58c0a0bc.png";